import { render, staticRenderFns } from "./WorkerFailed.vue?vue&type=template&id=4b4c56de&"
import script from "./WorkerFailed.vue?vue&type=script&lang=js&"
export * from "./WorkerFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports